export function request(tagId, query) {
    return {
        type: 'GET_MARKETS_FOR_TAG_REQUEST',
        query,
        tagId
    };
}

export function error(errors) {
    return {
        type: 'GET_MARKETS_FOR_TAG_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'GET_MARKETS_FOR_TAG_FINISH',
        data
    };
}
